import React from 'react';
import fieldStyles from '../../stylesheets/maintenance/detailsField.module.scss';

interface DetailsFieldWithIconProps {
  label: string;
  value: string;
}

const DetailsFieldWithIcon = ({ label, value }: DetailsFieldWithIconProps) => {
  return (
    <div className={fieldStyles.detailsFieldRow}>
      <div className={fieldStyles.detailsField}>
        <div className={fieldStyles.detailsFieldLabel}>{label}</div>
        <div className={fieldStyles.detailsFieldValue}>{value}</div>
      </div>
      <button className={fieldStyles.detailsInfoButton} type="button">
        i
      </button>
    </div>
  );
};

export default DetailsFieldWithIcon;
